
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "FileObjectLocation": [
      "BackupStorageLocation",
      "CustomLocation",
      "GCSLocation",
      "JetStorageLocation"
    ],
    "Job": [
      "CheckUserRolesJob",
      "SendNotificationsJob",
      "SendPrayerNotificationJob",
      "SendVideoExperienceNotificationJob"
    ],
    "Notification": [
      "PrayerNotification",
      "VideoExperienceNotification"
    ],
    "NotificationChannel": [
      "EmailNotificationChannel",
      "SlackChannel"
    ],
    "PrayerTalkSlide": [
      "PrayerTalkPrayerRequestSlide",
      "PrayerTalkReviewSlide",
      "PrayerTalkSimpleQuoteSlide",
      "PrayerTalkStartCoverSlide",
      "PrayerTalkTextOnPadSlide",
      "PrayerTalkTextWithDisappearingSlide",
      "PrayerTalkUserCommentSlide",
      "PrayerTalkVoiceoverOnlySlide"
    ],
    "PrayerTalkSlideComponent": [
      "PrayerTalkSlidePrayerRequestComponent",
      "PrayerTalkSlideReviewComponent",
      "PrayerTalkSlideSimpleQuoteComponent",
      "PrayerTalkSlideStartCoverComponent",
      "PrayerTalkSlideTextOnPadComponent",
      "PrayerTalkSlideTextWithDisappearingComponent",
      "PrayerTalkSlideUserCommentComponent",
      "PrayerTalkSlideVoiceoverOnlyComponent"
    ],
    "PrayerTalkSlideComponentProps": [
      "PrayerRequestComponentProps",
      "ReviewComponentProps",
      "SimpleQuoteComponentProps",
      "StartCoverComponentProps",
      "TextOnPadComponentProps",
      "TextWithDisappearingComponentProps",
      "UserCommentComponentProps",
      "VoiceoverOnlyComponentProps"
    ],
    "PrayerTalkSlideProps": [
      "PrayerTalkPrayerRequestSlideProps",
      "PrayerTalkReviewSlideProps",
      "PrayerTalkSimpleQuoteSlideProps",
      "PrayerTalkStartCoverSlideProps",
      "PrayerTalkTextOnPadSlideProps",
      "PrayerTalkTextWithDisappearingSlideProps",
      "PrayerTalkUserCommentSlideProps",
      "PrayerTalkVoiceoverOnlySlideProps"
    ],
    "RPSlideComponent": [
      "RPBiblePassageComponent",
      "RPFooterComponent",
      "RPSimpleQuoteComponent",
      "RPStartCoverComponent",
      "RPTextComponent"
    ],
    "RPSlideComponentProps": [
      "RPBiblePassageComponentProps",
      "RPFooterComponentProps",
      "RPSimpleQuoteComponentProps",
      "RPStartCoverComponentProps",
      "RPTextComponentProps"
    ],
    "ReadingPlanSlide": [
      "RPBiblePassageSlide",
      "RPFooterSlide",
      "RPSimpleQuoteSlide",
      "RPStartCoverSlide",
      "RPTextSlide"
    ],
    "ReadingPlanSlideProps": [
      "RPBiblePassageSlideProps",
      "RPFooterSlideProps",
      "RPSimpleQuoteSlideProps",
      "RPStartCoverSlideProps",
      "RPTextSlideProps"
    ]
  }
};
      export default result;
    